@if (iframeUrl()) {
  <app-iframe [src]="iframeUrl()"></app-iframe>
}